(function () {
  var BREVO_API_KEY = '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';
  var BREVO_LIST_ID = 7;
  var SENDER_EMAIL = 'benjamanus.15@gmail.com';
  var SENDER_NAME = 'Agatamoon';
  var COUPON = 'AGATA10';
  var VERSION  = 'v3';
  var SUB_KEY  = 'pj_popnl_subscribed_' + VERSION;
  var SES_KEY  = 'pj_popnl_seen_' + VERSION;
  /* Limpia claves de versiones anteriores para que el popup reaparezca */
  try {
    ['pj_popnl_subscribed','pj_popnl_seen_session',
     'pj_popnl_subscribed_v1','pj_popnl_seen_v1',
     'pj_popnl_subscribed_v2','pj_popnl_seen_v2'].forEach(function(k) {
      localStorage.removeItem(k); sessionStorage.removeItem(k);
    });
  } catch(e) {}
  var root = document.getElementById('PjPopupAg');
  if (!root) return;
  var overlay      = root.querySelector('[data-popup-overlay]');
  var closeButtons = root.querySelectorAll('[data-popup-close]');
  var form         = root.querySelector('[data-popup-form]');
  var nameInput    = root.querySelector('[data-popup-name]');
  var emailInput   = root.querySelector('[data-popup-email]');
  var emailError   = root.querySelector('[data-popup-error]');
  var submitBtn    = root.querySelector('[data-popup-submit]');
  var ctaText      = root.querySelector('[data-popup-cta-text]');
  var ctaLoading   = root.querySelector('[data-popup-cta-loading]');
  var formState    = root.querySelector('[data-popup-state="form"]');
  var successState = root.querySelector('[data-popup-state="success"]');
  function ls(k)      { try { return localStorage.getItem(k); }   catch(e) { return null; } }
  function lsSet(k,v) { try { localStorage.setItem(k,v); }         catch(e) {} }
  function ss(k)      { try { return sessionStorage.getItem(k); }  catch(e) { return null; } }
  function ssSet(k,v) { try { sessionStorage.setItem(k,v); }       catch(e) {} }
  function shouldShow() { return ls(SUB_KEY) !== '1' && ss(SES_KEY) !== '1'; }
  function showPopup() {
    if (!shouldShow()) return;
    ssSet(SES_KEY, '1');
    root.hidden = false;
    requestAnimationFrame(function () { root.classList.add('is-visible'); });
    document.documentElement.classList.add('pj-popupnl-open');
    document.body.classList.add('pj-popupnl-open');
    if (nameInput) setTimeout(function () { nameInput.focus(); }, 250);
  }
  function hidePopup() {
    root.classList.remove('is-visible');
    document.documentElement.classList.remove('pj-popupnl-open');
    document.body.classList.remove('pj-popupnl-open');
    setTimeout(function () { if (!root.classList.contains('is-visible')) root.hidden = true; }, 260);
  }
  function setLoading(s) {
    if (!submitBtn) return;
    submitBtn.disabled = !!s;
    if (ctaText)    ctaText.hidden    = !!s;
    if (ctaLoading) ctaLoading.hidden = !s;
  }
  function showError(msg) {
    if (emailInput) emailInput.classList.add('is-error');
    if (emailError) { emailError.textContent = msg || 'Revisa el correo o intentalo de nuevo.'; emailError.hidden = false; }
    setLoading(false);
  }
  function clearError() {
    if (emailInput) emailInput.classList.remove('is-error');
    if (emailError) emailError.hidden = true;
  }
  function showSuccess() {
    if (formState)    formState.hidden    = true;
    if (successState) successState.hidden = false;
    setLoading(false);
  }
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((v || '').trim()); }
  function escapeHtml(v) {
    return String(v || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#039;');
  }
  function addToBrevo(email, firstName) {
    return fetch('https://api.brevo.com/v3/contacts', {
      method: 'POST',
      headers: { 'api-key': BREVO_API_KEY, 'Content-Type': 'application/json', 'accept': 'application/json' },
      body: JSON.stringify({ email: email, attributes: { FIRSTNAME: firstName || '' }, listIds: [BREVO_LIST_ID], updateEnabled: true })
    }).catch(function () {});
  }

  function buildEmailHtml(fn, coupon) {
    var safeName   = escapeHtml(fn || '');
    var safeCoupon = escapeHtml(coupon || 'AGATA10');
    var welcomeName = safeName ? ' ' + safeName : '';

    var gemIcon = '<svg width="40" height="48" viewBox="0 0 40 48" xmlns="http://www.w3.org/2000/svg"><polygon points="20,3 38,14 38,34 20,45 2,34 2,14" fill="#EFE4F8" stroke="#7B4FA6" stroke-width="1.5"/><polygon points="20,3 38,14 20,21 2,14" fill="#D8C0F0" opacity="0.8"/><line x1="2" y1="14" x2="38" y2="14" stroke="#7B4FA6" stroke-width="0.8" opacity="0.35"/><line x1="20" y1="21" x2="20" y2="45" stroke="#7B4FA6" stroke-width="0.8" opacity="0.3"/><line x1="2" y1="34" x2="38" y2="34" stroke="#7B4FA6" stroke-width="0.7" opacity="0.22"/></svg>';

    var botLeft = '<svg width="58" height="170" viewBox="0 0 58 170" xmlns="http://www.w3.org/2000/svg"><g opacity="0.30"><path d="M29,168 C25,138 23,114 27,92 C31,98 32,118 29,138 C35,114 39,90 31,64 C37,76 40,96 35,116 C43,86 45,62 35,36 C43,52 47,76 39,104" stroke="#7B4FA6" stroke-width="1.8" fill="none" stroke-linecap="round" stroke-linejoin="round"/><ellipse cx="27" cy="92" rx="14" ry="8" fill="#C0A0DC" opacity="0.65" transform="rotate(-22 27 92)"/><ellipse cx="31" cy="64" rx="12" ry="7" fill="#C0A0DC" opacity="0.6" transform="rotate(12 31 64)"/><ellipse cx="35" cy="36" rx="13" ry="7.5" fill="#C0A0DC" opacity="0.62" transform="rotate(-6 35 36)"/><circle cx="35" cy="36" r="3.8" fill="#A880C8" opacity="0.9"/><circle cx="27" cy="92" r="4.2" fill="#A880C8" opacity="0.8"/><circle cx="31" cy="64" r="3.4" fill="#A880C8" opacity="0.85"/></g></svg>';

    var botRight = '<svg width="58" height="170" viewBox="0 0 58 170" xmlns="http://www.w3.org/2000/svg"><g opacity="0.30"><path d="M29,168 C33,138 35,114 31,92 C27,98 26,118 29,138 C23,114 19,90 27,64 C21,76 18,96 23,116 C15,86 13,62 23,36 C15,52 11,76 19,104" stroke="#7B4FA6" stroke-width="1.8" fill="none" stroke-linecap="round" stroke-linejoin="round"/><ellipse cx="31" cy="92" rx="14" ry="8" fill="#C0A0DC" opacity="0.65" transform="rotate(22 31 92)"/><ellipse cx="27" cy="64" rx="12" ry="7" fill="#C0A0DC" opacity="0.6" transform="rotate(-12 27 64)"/><ellipse cx="23" cy="36" rx="13" ry="7.5" fill="#C0A0DC" opacity="0.62" transform="rotate(6 23 36)"/><circle cx="23" cy="36" r="3.8" fill="#A880C8" opacity="0.9"/><circle cx="31" cy="92" r="4.2" fill="#A880C8" opacity="0.8"/><circle cx="27" cy="64" r="3.4" fill="#A880C8" opacity="0.85"/></g></svg>';

    var quoteOpen  = '<svg width="38" height="30" viewBox="0 0 38 30" xmlns="http://www.w3.org/2000/svg"><path d="M0,30 C0,18 5,8 16,0 L20,5 C13,10 10,16 11,22 C11,26 14,28 18,28 C22,28 24,25 24,21 C24,17 21,14 16,14 L14,8 C24,8 30,14 30,22 C30,27 26,30 19,30 Z" fill="#C0A0DC" opacity="0.35"/></svg>';
    var quoteClose = '<svg width="38" height="30" viewBox="0 0 38 30" xmlns="http://www.w3.org/2000/svg"><path d="M38,0 C38,12 33,22 22,30 L18,25 C25,20 28,14 27,8 C27,4 24,2 20,2 C16,2 14,5 14,9 C14,13 17,16 22,16 L24,22 C14,22 8,16 8,8 C8,3 12,0 19,0 Z" fill="#C0A0DC" opacity="0.35"/></svg>';

    var deliveryIcon = '<svg width="34" height="26" viewBox="0 0 34 26" xmlns="http://www.w3.org/2000/svg"><rect x="1" y="1" width="22" height="16" rx="2" fill="none" stroke="#7B4FA6" stroke-width="1.5"/><path d="M23,6 L31,6 L33,12 L33,18 L23,18 Z" fill="none" stroke="#7B4FA6" stroke-width="1.5"/><circle cx="7" cy="21" r="3" fill="none" stroke="#7B4FA6" stroke-width="1.5"/><circle cx="27" cy="21" r="3" fill="none" stroke="#7B4FA6" stroke-width="1.5"/></svg>';
    var handIcon     = '<svg width="34" height="34" viewBox="0 0 34 34" xmlns="http://www.w3.org/2000/svg"><path d="M17,4 C17,4 10,8 10,16 L10,22 C10,26 13,29 17,29 C21,29 24,26 24,22 L24,16 C24,8 17,4 17,4 Z" fill="none" stroke="#7B4FA6" stroke-width="1.5"/><path d="M13,22 C11,20 9,17 10,14" stroke="#7B4FA6" stroke-width="1.2" fill="none"/><path d="M21,22 C23,20 25,17 24,14" stroke="#7B4FA6" stroke-width="1.2" fill="none"/><path d="M14,12 C14,9 16,7 17,6" stroke="#7B4FA6" stroke-width="1.2" fill="none"/></svg>';
    var stoneIcon    = '<svg width="34" height="34" viewBox="0 0 34 34" xmlns="http://www.w3.org/2000/svg"><polygon points="17,3 30,10 30,24 17,31 4,24 4,10" fill="none" stroke="#7B4FA6" stroke-width="1.5"/><polygon points="17,3 30,10 17,16 4,10" fill="#EFE4F8" opacity="0.7"/><line x1="4" y1="10" x2="30" y2="10" stroke="#7B4FA6" stroke-width="0.8" opacity="0.4"/><line x1="17" y1="16" x2="17" y2="31" stroke="#7B4FA6" stroke-width="0.8" opacity="0.3"/></svg>';

    return [
      '<!DOCTYPE html><html lang="es" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">',
      '<head><meta charset="UTF-8"/>',
      '<meta name="viewport" content="width=device-width,initial-scale=1.0"/>',
      '<meta name="color-scheme" content="light only"/>',
      '<meta name="supported-color-schemes" content="light"/>',
      '<!--[if mso]><noscript><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml></noscript><![endif]-->',
      '<style>',
      '*{margin:0;padding:0;box-sizing:border-box;}',
      ':root{color-scheme:light only;}',
      'body,html{background-color:#F3EFE8!important;font-family:Georgia,serif;color:#2D1B4E;}',
      '.ew{max-width:620px;margin:0 auto;background-color:#FBF8F5!important;}',
      '.tb{background-color:#EFE3F8!important;padding:12px 24px;text-align:center;border-bottom:1px solid rgba(45,27,78,0.08);}',
      '.tbt{font-size:10.5px;font-weight:600;letter-spacing:0.18em;color:#3A245C!important;text-transform:uppercase;font-family:Arial,sans-serif;}',
      '.ts{color:#8D65B8!important;margin:0 10px;}',
      '.hd{background-color:#FBF8F5!important;padding:34px 40px 28px;text-align:center;border-bottom:1px solid rgba(45,27,78,0.1);}',
      '.logo-wrap{display:inline-block;background-color:#ffffff!important;border-radius:10px;padding:10px 18px;}',
      '.logo{display:block;height:auto;max-width:190px;border:0;}',
      '.bsub{font-size:10px;font-weight:600;letter-spacing:0.34em;color:#7B4FA6!important;text-transform:uppercase;margin-top:6px;font-family:Arial,sans-serif;}',
      '.hr{background:#F7F1FA!important;padding:48px 0 44px;text-align:center;border-bottom:1px solid rgba(45,27,78,0.08);}',
      '.he{font-size:10px;font-weight:700;letter-spacing:0.34em;text-transform:uppercase;color:#3A245C!important;margin-bottom:22px;font-family:Arial,sans-serif;}',
      '.ht{font-family:Georgia,serif;font-size:42px;font-weight:400;color:#2D1B4E!important;line-height:1.12;}',
      '.hi{font-family:Georgia,serif;font-size:42px;font-weight:400;font-style:italic;color:#7B4FA6!important;line-height:1.12;display:block;}',
      '.hdc{font-size:15px;line-height:1.8;color:rgba(45,27,78,0.72)!important;max-width:340px;margin:26px auto 0;font-family:Arial,sans-serif;}',
      '.cs{background:#FBF8F5!important;padding:50px 40px 24px;text-align:center;}',
      '.cl{font-size:10px;font-weight:700;letter-spacing:0.4em;text-transform:uppercase;color:#7B4FA6!important;margin-bottom:24px;font-family:Arial,sans-serif;}',
      '.cb{border:1.5px solid rgba(123,79,166,0.28);border-radius:8px;overflow:hidden;background:#FBF8F5!important;}',
      '.ct{background:#F0E4F8!important;padding:34px 32px 30px;text-align:center;border-bottom:1px solid rgba(123,79,166,0.16);}',
      '.cn{font-family:Georgia,serif;font-size:92px;font-weight:700;color:#7B4FA6!important;line-height:0.85;letter-spacing:-0.02em;}',
      '.cpct{font-family:Georgia,serif;font-size:34px;font-weight:400;color:#3A245C!important;vertical-align:top;line-height:1.4;}',
      '.co{font-family:Georgia,serif;font-size:17px;font-style:italic;color:#7B4FA6!important;display:block;margin-top:10px;letter-spacing:0.04em;}',
      '.cbot{background:#FBF8F5!important;padding:28px 32px;}',
      '.ccl{font-size:10px;font-weight:700;letter-spacing:0.35em;text-transform:uppercase;color:rgba(45,27,78,0.55)!important;margin-bottom:12px;font-family:Arial,sans-serif;}',
      '.cc{display:inline-block;font-family:Georgia,serif;font-size:27px;font-weight:400;letter-spacing:0.34em;color:#2D1B4E!important;background:#F7F1FA!important;border:1.5px dashed rgba(123,79,166,0.42);padding:11px 30px;border-radius:4px;}',
      '.cno{font-size:12px;color:rgba(45,27,78,0.52)!important;margin-top:14px;font-family:Arial,sans-serif;}',
      '.ctas{background:#FBF8F5!important;padding:20px 40px 52px;text-align:center;}',
      '.ctab{display:inline-block;background-color:#EFE3F8!important;color:#2D1B4E!important;border:1.5px solid #7B4FA6;font-family:Arial,sans-serif;font-size:11.5px;font-weight:700;letter-spacing:0.26em;text-transform:uppercase;text-decoration:none;padding:18px 52px;border-radius:40px;}',
      '.ctan{margin-top:16px;font-size:12px;color:rgba(45,27,78,0.5)!important;font-family:Arial,sans-serif;}',
      '.sd{height:1px;background:rgba(45,27,78,0.1);margin:0 40px;}',
      '.ss{background:#F7F1FA!important;padding:50px 48px 46px;text-align:center;}',
      '.sl{font-size:10px;font-weight:700;letter-spacing:0.4em;text-transform:uppercase;color:#7B4FA6!important;margin-bottom:18px;font-family:Arial,sans-serif;}',
      '.st{font-family:Georgia,serif;font-size:27px;font-weight:400;color:#2D1B4E!important;margin-bottom:18px;line-height:1.3;}',
      '.stx{font-size:14.5px;line-height:1.85;color:rgba(45,27,78,0.68)!important;max-width:440px;margin:0 auto;font-family:Arial,sans-serif;}',
      '.bs2{background:#FBF8F5!important;padding:46px 32px;border-top:1px solid rgba(45,27,78,0.08);border-bottom:1px solid rgba(45,27,78,0.08);}',
      '.bt2{font-size:10px;font-weight:700;letter-spacing:0.4em;text-transform:uppercase;color:#7B4FA6!important;text-align:center;margin-bottom:32px;font-family:Arial,sans-serif;}',
      '.bef{display:table-cell;width:33.33%;text-align:center;padding:0 14px;vertical-align:top;}',
      '.bet{font-family:Georgia,serif;font-size:14.5px;font-weight:700;color:#2D1B4E!important;margin-bottom:8px;line-height:1.3;margin-top:10px;}',
      '.beb{font-size:11.5px;color:rgba(45,27,78,0.6)!important;line-height:1.7;font-family:Arial,sans-serif;}',
      '.qs{padding:52px 56px;text-align:center;background:#F7F1FA!important;border-bottom:1px solid rgba(45,27,78,0.08);}',
      '.qb{font-family:Georgia,serif;font-size:21px;font-style:italic;font-weight:400;color:#2D1B4E!important;line-height:1.65;max-width:420px;margin:0 auto;}',
      '.qa{display:block;margin-top:20px;font-size:10.5px;font-weight:700;letter-spacing:0.25em;color:rgba(45,27,78,0.46)!important;text-transform:uppercase;font-family:Arial,sans-serif;}',
      '.ft{background:#FBF8F5!important;padding:42px 40px 34px;text-align:center;}',
      '.flogo{font-family:Georgia,serif;font-size:28px;font-weight:400;letter-spacing:0.08em;color:#2D1B4E!important;}',
      '.fsub{font-size:10px;font-weight:600;letter-spacing:0.28em;text-transform:uppercase;color:#7B4FA6!important;margin-top:8px;font-family:Arial,sans-serif;}',
      '.fdiv{width:44px;height:1px;background:rgba(123,79,166,0.22);margin:24px auto;}',
      '.fna a{font-size:11px;color:#3A245C!important;text-decoration:none;letter-spacing:0.2em;text-transform:uppercase;margin:0 14px;font-family:Arial,sans-serif;font-weight:700;}',
      '.flg{font-size:11px;color:rgba(45,27,78,0.52)!important;line-height:1.9;font-family:Arial,sans-serif;margin-top:16px;}',
      '.fmd{margin-top:18px;font-size:10px;color:rgba(123,79,166,0.65)!important;letter-spacing:0.2em;text-transform:uppercase;font-family:Arial,sans-serif;}',
      '@media(prefers-color-scheme:dark){',
      'body,html{background-color:#F3EFE8!important;}',
      '.ew{background-color:#FBF8F5!important;}',
      '.tb{background-color:#EFE3F8!important;}',
      '.hd{background-color:#FBF8F5!important;}',
      '.logo-wrap{background-color:#ffffff!important;}',
      '.hr{background:#F7F1FA!important;}',
      '.cs,.ctas,.cbot,.ft{background:#FBF8F5!important;}',
      '.ct{background:#F0E4F8!important;}',
      '.cc{background:#F7F1FA!important;}',
      '.ss,.qs{background:#F7F1FA!important;}',
      '.bs2{background:#FBF8F5!important;}',
      '.tbt,.he,.ht,.hdc,.cl,.ccl,.cno,.ctan,.sl,.st,.stx,.bt2,.bet,.beb,.qa,.flogo,.fsub,.flg,.fmd{color:#2D1B4E!important;}',
      '.ts,.bsub,.cl,.sl,.bt2,.fsub,.fmd{color:#7B4FA6!important;}',
      '.hi,.co,.cn,.cc{color:#7B4FA6!important;}',
      '.ctab{background-color:#EFE3F8!important;color:#2D1B4E!important;}',
      '}',
      '[data-ogsc] body,[data-ogsc] html{background-color:#F3EFE8!important;}',
      '[data-ogsc] .ew{background-color:#FBF8F5!important;}',
      '[data-ogsc] .tb{background-color:#EFE3F8!important;}',
      '[data-ogsc] .hd{background-color:#FBF8F5!important;}',
      '[data-ogsc] .logo-wrap{background-color:#ffffff!important;}',
      '[data-ogsc] .hr{background:#F7F1FA!important;}',
      '[data-ogsc] .cs,[data-ogsc] .ctas,[data-ogsc] .cbot,[data-ogsc] .ft{background:#FBF8F5!important;}',
      '[data-ogsc] .ct{background:#F0E4F8!important;}',
      '[data-ogsc] .cc{background:#F7F1FA!important;}',
      '[data-ogsc] .ss,[data-ogsc] .qs{background:#F7F1FA!important;}',
      '[data-ogsc] .bs2{background:#FBF8F5!important;}',
      '[data-ogsc] .tbt,[data-ogsc] .he,[data-ogsc] .ht,[data-ogsc] .hdc,[data-ogsc] .st,[data-ogsc] .stx,[data-ogsc] .bet,[data-ogsc] .beb,[data-ogsc] .qb,[data-ogsc] .flogo{color:#2D1B4E!important;}',
      '[data-ogsc] .hi,[data-ogsc] .co,[data-ogsc] .cn,[data-ogsc] .cc{color:#7B4FA6!important;}',
      '[data-ogsc] .ctab{background-color:#EFE3F8!important;color:#2D1B4E!important;}',
      '@media only screen and (max-width:480px){',
      '.ew{width:100%!important;}',
      '.tb{padding:10px 12px;}',
      '.tbt{font-size:9px;}',
      '.hd{padding:28px 20px 24px;}',
      '.ht,.hi{font-size:32px;}',
      '.hdc{font-size:13.5px;}',
      '.cs{padding:42px 20px 20px;}',
      '.cn{font-size:76px;}',
      '.cc{font-size:22px;letter-spacing:0.24em;padding:10px 20px;}',
      '.ctas{padding:18px 20px 44px;}',
      '.ctab{padding:17px 28px;font-size:10.5px;}',
      '.ss{padding:44px 24px;}',
      '.st{font-size:24px;}',
      '.qs{padding:44px 26px;}',
      '.qb{font-size:18px;}',
      '.ft{padding:38px 24px 32px;}',
      '.bef{display:block!important;width:100%!important;padding:18px 10px!important;border-left:none!important;border-top:1px solid rgba(123,79,166,0.18);}',
      '.bef:first-child{border-top:none!important;}',
      '}',
      '</style></head><body style="margin:0;padding:0;background-color:#F3EFE8;">',
      '<div class="ew" style="max-width:620px;margin:0 auto;background-color:#FBF8F5;">',

        '<div class="tb">',
          '<span class="tbt">Envío gratis sobre $60.000</span>',
          '<span class="ts">&#9670;</span>',
          '<span class="tbt">100% hecho a mano</span>',
          '<span class="ts">&#9670;</span>',
          '<span class="tbt">Pago seguro garantizado</span>',
        '</div>',

        '<div class="hd">',
          '<div class="logo-wrap">',
            '<img class="logo" src="https://agatamoon.cl/cdn/shop/files/Sin_titulo.jpg" alt="Agatamoon" width="190" height="auto" style="display:block;border:0;max-width:190px;height:auto;"/>',
          '</div>',
          '<div class="bsub" style="margin-top:10px;">Joyería artesanal &nbsp;&#183;&nbsp; Piedras naturales</div>',
        '</div>',

        '<div class="hr">',
          '<table width="100%" cellpadding="0" cellspacing="0" style="border-collapse:collapse;">',
            '<tr>',
              '<td width="68" style="vertical-align:bottom;padding-bottom:8px;padding-left:8px;">' + botLeft + '</td>',
              '<td style="text-align:center;vertical-align:middle;padding:0 12px;">',
                '<div class="he">Bienvenida' + welcomeName + ' a nuestra comunidad</div>',
                '<div class="ht">Piedras que</div>',
                '<span class="hi">cuentan historias</span>',
                '<p class="hdc">Gracias por unirte. Eres parte de una comunidad que cree en la belleza de lo auténtico, lo hecho a mano y la energía que cada piedra lleva consigo.</p>',
              '</td>',
              '<td width="68" style="vertical-align:bottom;padding-bottom:8px;padding-right:8px;">' + botRight + '</td>',
            '</tr>',
          '</table>',
        '</div>',

        '<div class="cs">',
          '<div class="cl">Tu regalo de bienvenida</div>',
          '<div class="cb">',
            '<div class="ct">',
              '<div style="line-height:1;"><span class="cn">10</span><span class="cpct">%</span></div>',
              '<span class="co">de descuento en tu primera compra</span>',
            '</div>',
            '<div class="cbot">',
              '<div class="ccl">Ingresa el código</div>',
              '<div class="cc">' + safeCoupon + '</div>',
              '<div class="cno">Sin mínimo de compra &nbsp;&#183;&nbsp; Válido por 30 días</div>',
            '</div>',
          '</div>',
        '</div>',

        '<div class="ctas">',
          '<a href="https://agatamoon.cl/collections" class="ctab" style="display:inline-block;background-color:#EFE3F8;color:#2D1B4E;border:1.5px solid #7B4FA6;font-family:Arial,sans-serif;font-size:11.5px;font-weight:700;letter-spacing:0.26em;text-transform:uppercase;text-decoration:none;padding:18px 52px;border-radius:40px;">Descubrir la colección</a>',
          '<div class="ctan">+40 variedades de piedras naturales &nbsp;&#183;&nbsp; Envíos a todo Chile</div>',
        '</div>',

        '<div class="sd"></div>',

        '<div class="ss">',
          '<div class="sl">Nuestra historia</div>',
          '<div class="st">Joyería con alma, hecha en Chile</div>',
          '<p class="stx">Cada pieza que creamos comienza con la selección de la mejor piedra y termina con un acabado impecable hecho completamente a mano. Elegimos cada piedra no solo por su belleza, sino también por su energía, porque creemos que una joya debe ser una extensión de quien la lleva.</p>',
        '</div>',

        '<div class="bs2">',
          '<div class="bt2">Por qué Agatamoon</div>',
          '<table width="100%" cellpadding="0" cellspacing="0" style="border-collapse:collapse;">',
            '<tr>',
              '<td class="bef" style="text-align:center;vertical-align:top;padding:0 14px;">',
                stoneIcon,
                '<div class="bet">Piedras Naturales</div>',
                '<div class="beb">Más de 40 piedras auténticas seleccionadas a mano</div>',
              '</td>',
              '<td class="bef" style="text-align:center;vertical-align:top;padding:0 14px;border-left:1px solid rgba(123,79,166,0.18);">',
                handIcon,
                '<div class="bet">100% Artesanal</div>',
                '<div class="beb">Cada pieza única, elaborada con técnicas tradicionales</div>',
              '</td>',
              '<td class="bef" style="text-align:center;vertical-align:top;padding:0 14px;border-left:1px solid rgba(123,79,166,0.18);">',
                deliveryIcon,
                '<div class="bet">Envío Gratis</div>',
                '<div class="beb">Sobre $60.000 a cualquier rincón de Chile</div>',
              '</td>',
            '</tr>',
          '</table>',
        '</div>',

        '<div class="qs">',
          '<table width="100%" cellpadding="0" cellspacing="0"><tr>',
            '<td width="44" style="vertical-align:top;padding-top:4px;">' + quoteOpen + '</td>',
            '<td style="text-align:center;padding:0 10px;">',
              '<div class="qb">No hay dos piezas iguales, así como no hay dos personas iguales. Tu joya nació para ti.</div>',
              '<span class="qa">Agatamoon &nbsp;&#183;&nbsp; Hecho con amor en Chile</span>',
            '</td>',
            '<td width="44" style="vertical-align:bottom;padding-bottom:4px;">' + quoteClose + '</td>',
          '</tr></table>',
        '</div>',

        '<div class="ft">',
          '<div class="flogo">Agatamoon</div>',
          '<div class="fsub">Joyería artesanal &nbsp;&#183;&nbsp; Piedras naturales &nbsp;&#183;&nbsp; Chile</div>',
          '<div class="fdiv"></div>',
          '<div class="fna">',
            '<a href="https://agatamoon.cl/collections" style="font-size:11px;color:#3A245C;text-decoration:none;letter-spacing:0.2em;text-transform:uppercase;margin:0 14px;font-family:Arial,sans-serif;font-weight:700;">Colección</a>',
            '<a href="https://agatamoon.cl/pages/ayuda" style="font-size:11px;color:#3A245C;text-decoration:none;letter-spacing:0.2em;text-transform:uppercase;margin:0 14px;font-family:Arial,sans-serif;font-weight:700;">Ayuda</a>',
          '</div>',
          '<div class="flg">Recibiste este correo porque te suscribiste en agatamoon.cl</div>',
          '<div class="fmd">Santiago de Chile 2025</div>',
        '</div>',

      '</div>',
      '</body></html>'
    ].join('');
  }

  function sendWelcomeEmail(email, firstName) {
    var html = buildEmailHtml(firstName, COUPON);
    return fetch('https://api.brevo.com/v3/smtp/email', {
      method: 'POST',
      headers: { 'api-key': BREVO_API_KEY, 'Content-Type': 'application/json', 'accept': 'application/json' },
      body: JSON.stringify({
        sender: { name: SENDER_NAME, email: SENDER_EMAIL },
        to: [{ email: email, name: firstName || '' }],
        subject: 'Tu descuento de bienvenida: ' + COUPON,
        htmlContent: html
      })
    }).catch(function () {});
  }

  if (overlay) overlay.addEventListener('click', hidePopup);
  closeButtons.forEach(function (b) { b.addEventListener('click', hidePopup); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-visible')) hidePopup();
  });
  if (emailInput) emailInput.addEventListener('input', clearError);
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var firstName = nameInput ? nameInput.value.trim() : '';
      var email = emailInput ? emailInput.value.trim() : '';
      if (!validEmail(email)) { showError('Revisa el correo o intentalo de nuevo.'); return; }
      clearError();
      setLoading(true);
      Promise.all([
        addToBrevo(email, firstName),
        sendWelcomeEmail(email, firstName)
      ]).then(function () {
        lsSet(SUB_KEY, '1'); ssSet(SES_KEY, '1'); showSuccess();
      }).catch(function () {
        lsSet(SUB_KEY, '1'); ssSet(SES_KEY, '1'); showSuccess();
      });
    });
  }
  function initPopup() {
    if (!root) return;
    if (shouldShow()) setTimeout(showPopup, 2500);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPopup);
  } else {
    initPopup();
  }
}());